import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';

import ui_onboardingListQuery from '@atlassian/jira-relay/src/__generated__/ui_onboardingListQuery.graphql';
import ui_insightsPanelQuery from '@atlassian/jira-relay/src/__generated__/ui_insightsPanelQuery.graphql';

export const onboardingHubEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-onboarding-hub" */ './src/ui'),
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => {
		const { cloudId } = tenantContext;

		const queries = {
			onboardingListQuery: {
				options: { fetchPolicy: 'store-and-network' as const },
				parameters: ui_onboardingListQuery,
				variables: { cloudId },
			},
			insightsQuery: {
				options: { fetchPolicy: 'store-and-network' as const },
				parameters: ui_insightsPanelQuery,
				variables: {
					cloudId,
					rollingIntervals: fg('jira-onboarding-hub-insights-gate')
						? [
								'DAYS_1' as const,
								'DAYS_7' as const,
								'DAYS_30' as const,
								'DAYS_90' as const,
								'DAYS_180' as const,
							]
						: [],
				},
			},
		};

		return { queries };
	},
});
